export const LOAD_HOUSE_DISBURSEMENTS_FAIL = 'LOAD_HOUSE_DISBURSEMENTS_FAIL';
export const LOAD_HOUSE_DISBURSEMENTS_REQUEST = 'LOAD_HOUSE_DISBURSEMENTS_REQUEST';
export const LOAD_HOUSE_DISBURSEMENTS_SUCCESS = 'LOAD_HOUSE_DISBURSEMENTS_SUCCESS';
